import React from 'react'
import { useTheme } from '@emotion/react'

export const LoadingSkeleton = () => {
    const theme = useTheme() as any

    return (
        <>
            <style>
                {`@keyframes sw-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
          @keyframes sw-pulse { 0% { opacity: 0.35; } 50% { opacity: 0.75; } 100% { opacity: 0.35; } }`}
            </style>
            <div style={{ padding: '14px 16px 10px 16px' }}>
                <div
                    style={{
                        padding: '14px 14px 12px 14px',
                        borderRadius: '10px',
                        border: `1px solid ${theme?.timelineDivider || '#e5e5e5'}`,
                        backgroundColor: theme?.rowOfDays?.background || '#ffffff',
                    }}
                >
                    <div style={{ flex: 1 }}>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 10,
                                marginBottom: 10,
                            }}
                        >
                            <div
                                style={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: '50%',
                                    border: `2px solid ${theme?.timelineDivider || '#e5e5e5'}`,
                                    borderTopColor: theme?.timelineScrubber?.primary || '#E6001E',
                                    animation: 'sw-spin 1s linear infinite',
                                    boxSizing: 'border-box',
                                }}
                            />
                            <div
                                style={{
                                    fontWeight: 700,
                                    fontSize: 14,
                                    color: theme?.text?.grey?.['300'] || '#333333',
                                }}
                            >
                                Loading schedule...
                            </div>
                        </div>
                        <div
                            style={{
                                height: 10,
                                borderRadius: 6,
                                backgroundColor: theme?.timelineDivider || '#e5e5e5',
                                marginBottom: 8,
                                animation: 'sw-pulse 1.4s ease-in-out infinite',
                            }}
                        />
                        <div
                            style={{
                                height: 10,
                                width: '72%',
                                borderRadius: 6,
                                backgroundColor: theme?.timelineDivider || '#e5e5e5',
                                animation: 'sw-pulse 1.4s ease-in-out infinite',
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
